import { isVinValid } from 'app/validators/validateCarVin';
import { LabelEnum } from 'app/shared/enums';

export default function validateVin(value: string) {
  return isVinValid(value) ? undefined : LabelEnum.InvalidVin;
}
